import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

export interface IClinicToDoctorRequestBody {
  clinic_id: string;
  doctor_id: string;
  direction: "clinic_to_doctor";
  target_status: "draft" | "pending";
  items: Array<{
    unique_row_id: string;
    qty: number;
    inventory_type: string;
  }>;
}

interface ICreateRequestResponseData {
  request_id: string;
}

interface ICreateRequestResponse {
  status: boolean;
  message: string;
  data?: ICreateRequestResponseData;
}

export const useCreateClinicToDoctorRequestAPI = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();

  const execute = useCallback(async (body: IClinicToDoctorRequestBody): Promise<{ status: boolean; request_id?: string }> => {
    setIsSubmitting(true);
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const res = await axios.post<ICreateRequestResponse>(
        INVENTORY_MODULE.CLINIC_TO_DOCTOR_REQUEST.baseURL,
        body,
        {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (res.data.status === true) {
        toast.success(res.data.message || "Transfer request created successfully");
        localStorage.removeItem("transfer_order_number");
        localStorage.removeItem("clinic_tams");
        localStorage.removeItem("senderClinic");
        return { status: true, request_id: res.data.data?.request_id };
      } else {
        toast.error(res.data.message || "Failed to create transfer request");
        return { status: false };
      }
    } catch (e: any) {
      if (e instanceof AxiosError) {
        captureError(e);
      }
      toast.error(e?.response?.data?.message || "Failed to create transfer request");
      return { status: false };
    } finally {
      setIsSubmitting(false);
    }
  }, []);

  return { execute, isSubmitting };
};
